module.exports = __webpack_public_path__ + "31cfd34d5092edb9ac3aedf9ad9b9ee1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mailbox_failed_2x.png
// module id = 40
// module chunks = 0 1 2 3 4